import * as React from 'react';
import { RatingList } from '../../components/RatingList';
import { useSelector } from 'react-redux';

import { RatingItemContainer } from '../RatingItemContainer';
import { useDeviceType } from '@cian/ui-kit';
import { RatingListMobile } from '../../components/RatingListMobile';
import { FailedRating } from '../../../regions/components/FailedRating';

import { useApplicationContext } from '../../../common/utils/applicationContext';
import { getRatingPosCount } from '../../../common/utils/getRatingPosCount';
import { selectIsFailed, selectIsLoading, selectRating } from '../../../common/selectors/rating';
import { selectFilters } from '../../../common/selectors/filters';

export const RatingListContainer: React.FC = () => {
  const rating = useSelector(selectRating);
  const loadingStatus = useSelector(selectIsLoading);
  const checkFailed = useSelector(selectIsFailed);
  const { region, type } = useSelector(selectFilters);

  const [expandedId, setExpandedId] = React.useState<number | null>(null);
  const [posCount, setPosCount] = React.useState<number>(0);
  const { config } = useApplicationContext();

  const ratingPosCount = getRatingPosCount(config, region.slug, type);

  React.useEffect(() => {
    setPosCount(ratingPosCount);
  }, [ratingPosCount]);

  const handleExpanded = React.useCallback(
    (id: number) => {
      setExpandedId(expandedId === id ? null : id);
    },
    [expandedId],
  );

  const device = useDeviceType();

  if (checkFailed) {
    return <FailedRating />;
  }

  const List = device === 'phone' ? RatingListMobile : RatingList;

  return (
    <List
      isLoadingRating={loadingStatus}
      agencies={rating
        ?.slice(0, posCount)
        .map((item, index) => (
          <RatingItemContainer
            key={index}
            agencyItem={item}
            expandedItem={expandedId}
            onExpandedItem={handleExpanded}
          />
        ))}
    />
  );
};
